import { render, staticRenderFns } from "./bgcs.vue?vue&type=template&id=0ecf725a&scoped=true&"
import script from "./bgcs.vue?vue&type=script&lang=js&"
export * from "./bgcs.vue?vue&type=script&lang=js&"
import style0 from "./bgcs.vue?vue&type=style&index=0&id=0ecf725a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf725a",
  null
  
)

export default component.exports